/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, threshold: NonNullable<unknown>, dimensions: NonNullable<unknown> }} Safe_Gray_Goat_StepInputs */

const en_safe_gray_goat_step = /** @type {(inputs: Safe_Gray_Goat_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hidden to prevent identification through combined attributes (${i?.count}/${i?.threshold} responses, attributes: ${i?.dimensions})`)
};

const de_safe_gray_goat_step = /** @type {(inputs: Safe_Gray_Goat_StepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausgeblendet, um Rückschlüsse aus kombinierten Merkmalen zu verhindern (${i?.count}/${i?.threshold} Antworten, Merkmale: ${i?.dimensions})`)
};

/**
* | output |
* | --- |
* | "Hidden to prevent identification through combined attributes ({count}/{threshold} responses, attributes: {dimensions})" |
*
* @param {Safe_Gray_Goat_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const safe_gray_goat_step = /** @type {((inputs: Safe_Gray_Goat_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Gray_Goat_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_gray_goat_step(inputs)
	return de_safe_gray_goat_step(inputs)
});